import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomPeople = createSvgIcon(
  <path d="M12 4.752a3.06 3.06 0 0 1 3.062 3.063A3.06 3.06 0 0 1 12 10.877a3.06 3.06 0 0 1-3.062-3.062A3.06 3.06 0 0 1 12 4.752m0 14.496a7.35 7.35 0 0 1-6.125-3.287c.03-2.032 4.083-3.144 6.125-3.144 2.031 0 6.094 1.112 6.125 3.144A7.35 7.35 0 0 1 12 19.248" />,
  'CustomPeople',
);

export default CustomPeople;
